import React from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';

export default class Fitting1ExportComponent extends React.Component {

  componentDidMount() {
  }

  render() {

    let alertDiv = null;
    if (this.props.alertStyle && this.props.alertStyle !== 'success') {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle}>
          {this.props.alertMessage}
        </Alert>
      )
    }

    let downloadLinkStyle = {
      display: (this.props.downloadUrl === '' || this.props.downloadUrl == null) ? 'none' : 'block'
    };

    let exportData = () => {
      this.props.exportData({ orderId: this.props.orderId })
    }

    let openFile = () => {
      window.open(this.props.downloadUrl);
    };

    return (
      <div>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={12} md={12}>
            {alertDiv}
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={12} md={12}>
            <label className="control-label" style={{ marginBottom: 20 }}>訂單編號: {this.props.orderId}</label>
          </Col>
          <Col xs={12} sm={12} md={12}>
            <Button block bsStyle="info" onClick={exportData} >
              匯出資料
            </Button>
            <br />
            <Button block bsStyle="default" onClick={openFile} style={downloadLinkStyle}>下載XLS檔</Button>
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/Fitting1ExportComponent.jsx